module.exports = __webpack_public_path__ + "img/diversos-icon.b63501a9.png";